'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "TableCellContentContainer": "Polaris-IndexTable-Checkbox__TableCellContentContainer",
  "Wrapper": "Polaris-IndexTable-Checkbox__Wrapper"
};

exports.default = styles;
